import K from "../managers/braze-instance.js";
import BrazeSdkMetadata from "./braze-sdk-metadata.js";
import {
  isArray as p,
  validateValueIsFromEnum as H,
} from "../util/code-utils.js";
import r from "../../shared-lib/braze-shared-lib.js";
export function addSdkMetadata(a) {
  if (!K.rr()) return;
  if (!p(a))
    return (
      r.j.error("Cannot set SDK metadata because metadata is not an array."), !1
    );
  for (const t of a)
    if (
      !H(
        BrazeSdkMetadata,
        t,
        "sdkMetadata contained an invalid value.",
        "BrazeSdkMetadata",
      )
    )
      return !1;
  const t = K.ar();
  return t && t.addSdkMetadata(a), !0;
}
